
import React from 'react';
import { Loader2, AlertCircle } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { Order } from './order-types';
import { useSales } from '@/hooks/useSales';
import SalesList from './SalesList';
import { ScrollArea } from '@/components/ui/scroll-area';
import { ShippingInfo } from './OrderActions';
import CancelOrderDialog from './CancelOrderDialog';

interface UserSalesProps {
  userId: string;
}

const UserSales = ({ userId }: UserSalesProps) => {
  const navigate = useNavigate();
  const { 
    sales, 
    isLoading, 
    error, 
    isUpdating, 
    updateOrderStatus,
    confirmCancellation,
    rejectCancellation,
    handleCancelOrder,
    confirmCancelOrder,
    cancelDialogOpen,
    setCancelDialogOpen,
    cancellationReason,
    setCancellationReason
  } = useSales(userId);

  // Event handlers
  const handleUpdateStatus = (orderId: string, newStatus: string, shippingInfo?: ShippingInfo) => {
   
    updateOrderStatus(orderId, newStatus, shippingInfo);
  };
  
  const handleViewListing = (listingId: number) => {
    navigate(`/product/${listingId}`);
  };

  const handleViewBuyerProfile = (buyerId: string) => {
    navigate(`/user-profile?user=${buyerId}`);
  };

  const handleContactBuyer = (order: Order) => {
    if (!order.buyer_profile?.id) return;
    navigate(`/messages`);
  };
  
  // Render loading state
  if (isLoading) {
    return (
      <div className="flex justify-center items-center p-8">
        <Loader2 className="h-8 w-8 animate-spin text-gray-400" />
      </div>
    );
  }
  
  // Render error state
  if (error) {
    return (
      <div className="text-center p-8">
        <AlertCircle className="mx-auto h-12 w-12 text-red-400" />
        <p className="mt-4 text-red-500">Gabim gjatë ngarkimit të shitjeve</p>
      </div>
    );
  }
  
  // Render empty state
  if (!sales || sales.length === 0) {
    return (
      <div className="text-center p-8">
        <p className="text-gray-500">Nuk keni shitje ende.</p>
      </div>
    );
  }
  
  // Render sales list
  return (
    <>
      <ScrollArea className="h-[60vh] md:h-[500px] w-full pr-4" type="always">
        <SalesList
          sales={sales}
          isUpdating={isUpdating}
          onViewListing={handleViewListing}
          onViewBuyerProfile={handleViewBuyerProfile}
          onContactBuyer={handleContactBuyer}
          onUpdateStatus={handleUpdateStatus}
          onCancelOrder={handleCancelOrder}
          onConfirmCancellation={confirmCancellation}
          onRejectCancellation={rejectCancellation}
        />
      </ScrollArea>

      {/* Cancel Order Dialog for seller */}
      <CancelOrderDialog
        open={cancelDialogOpen}
        onOpenChange={setCancelDialogOpen}
        onConfirm={confirmCancelOrder}
        isPending={isUpdating !== null}
        reason={cancellationReason}
        onReasonChange={setCancellationReason}
        title="Anulo Porosinë"
        description="Ju lutemi shpjegoni arsyen e anulimit të porosisë. Blerësi do të njoftohet."
      />
    </>
  );
};

export default UserSales;
